document.addEventListener('DOMContentLoaded', function () {
  var toggleButton = document.getElementById('custom_show_more_toggle-faqs');
  var additionalFaqs = document.getElementById('custom_show_more_additional-faqs');

  const accordionItems = document.querySelectorAll('.faq_accordion');

  accordionItems.forEach((item, index) => {
    const button = item.querySelector('.accordion_button');
    const content = item.querySelector('.accordion_content');

    item.addEventListener('click', function () {
      content.classList.toggle('show_content');
      button.style.animation = 'minus 0.5s 1 alternate forwards';
    });
  });

  if (toggleButton) {
    toggleButton.addEventListener('click', function () {
      if (additionalFaqs.classList.contains('show')) {
        additionalFaqs.classList.remove('show');
        toggleButton.textContent = 'Show more';

        toggleButton.scrollIntoView({ behavior: 'smooth', block: 'end' });
      } else {
        additionalFaqs.classList.add('show');
        toggleButton.textContent = 'Show less';
      }
    });
  }
});
